var map = {
	"./actions-tray/feature": [
		25954,
		5954
	],
	"./assets/feature": [
		85284,
		3016,
		5284
	],
	"./batching/feature": [
		66364,
		5097,
		7164,
		3016,
		1198,
		836,
		7012,
		6609,
		477,
		1800,
		656,
		9488,
		4054,
		5061
	],
	"./counterfactual/feature": [
		46528,
		3016,
		5097,
		5069,
		4163,
		8174,
		7012,
		2677,
		6790,
		477,
		1800,
		8830,
		8321,
		898,
		617,
		8201,
		493,
		6528
	],
	"./global-search/feature": [
		97802,
		8043,
		3016,
		4724,
		5988,
		3465
	],
	"./gtf/feature": [
		30582,
		3230,
		582
	],
	"./hypernative/feature": [
		59275,
		9596,
		8321,
		8477
	],
	"./ledger/feature": [
		61681,
		7164,
		1681
	],
	"./myAccounts/feature": [
		22666,
		3016,
		8043,
		5702,
		4724,
		2874,
		3888
	],
	"./nfts/feature": [
		35369,
		6660,
		3016,
		9484,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		7164,
		1065
	],
	"./oidc-auth/feature": [
		67990,
		6098,
		7990
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		61857,
		7164,
		3016,
		1198,
		836,
		5097,
		5069,
		7012,
		6609,
		2677,
		6790,
		7848,
		477,
		1800,
		656,
		9488,
		4054,
		8830,
		8515,
		2429,
		8224,
		8584,
		1712
	],
	"./security/feature": [
		65818,
		2677,
		4497,
		5818
	],
	"./spaces/feature": [
		22758,
		6835,
		3016,
		8043,
		4222,
		836,
		1198,
		7164,
		5097,
		7012,
		6609,
		2677,
		5420,
		5909,
		3202,
		477,
		1800,
		656,
		9488,
		4054,
		4497,
		4724,
		5988,
		4172
	],
	"./speedup/feature": [
		77363,
		3016,
		5097,
		477,
		2939
	],
	"./spending-limits/feature": [
		25456,
		3016,
		3483,
		5069,
		5097,
		7164,
		1198,
		836,
		8174,
		7012,
		6609,
		2677,
		6790,
		7848,
		2206,
		6033,
		5420,
		477,
		1800,
		656,
		9488,
		4054,
		8830,
		8321,
		898,
		617,
		8515,
		8201,
		2429,
		8224,
		5313,
		365,
		5456
	],
	"./stake/feature": [
		77754,
		7164,
		3016,
		1198,
		836,
		5097,
		7012,
		6609,
		477,
		1800,
		656,
		9488,
		4054,
		1728
	],
	"./support-chat/feature": [
		41029,
		1029
	],
	"./swap/feature": [
		21221,
		3016,
		1041,
		4054,
		4733
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./transactions/feature": [
		50374,
		836,
		3016,
		1198,
		7164,
		5097,
		7012,
		6609,
		477,
		1800,
		656,
		9488,
		4054,
		8584,
		8216
	],
	"./tx-notes/feature": [
		73322,
		3322
	],
	"./wallet/feature": [
		71993,
		4872,
		1993
	],
	"./walletconnect/feature": [
		4390,
		1520,
		7164,
		7012,
		6609,
		6847,
		8048,
		4390
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;